import React from 'react';

import MerchantSelect from '@components/operator/MerchantSelect';
import FlexibleProductEditView from '@components/shared/flexible_products/FlexibleProductEditView';
import { useOperatorProductService } from '@hooks/operator/products/useOperatorProductService';
import PageHeader from '@shared/PageHeader';

import operatorFlexibleProductService from '@services/operator/flexibleProductService';

export default function OperatorFlexibleProductNew() {
  const productService = useOperatorProductService();

  return (
    <MerchantSelect>
      {({ merchantId }) => (
        <div>
          <PageHeader items={['products', 'products.flexible_products', 'products.flexible_products.new']} />
          {merchantId && (
            <FlexibleProductEditView
              flexibleProductService={operatorFlexibleProductService}
              productService={productService}
              role="operator"
              merchantId={merchantId}
            />
          )}
        </div>
      )}
    </MerchantSelect>
  );
}
